/**
 * Consent Banner for GDPR reasons
 *
 * Shown for anonymous users
 *
 * @unstable
 */

import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zef-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class Consent {
  @Output() consentResult = new EventEmitter<boolean>();

  onAccept() {
    this.consentResult.emit(true);
  }

  onDecline() {
    this.consentResult.emit(false);
  }
}
